module.exports = __webpack_public_path__ + "static/img/inforImgLeft.3405cab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/inforImgLeft.png
// module id = hacy
// module chunks = 2